<div class="page-title-area page-title-four">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="page-title-item">
        <h2>{{'MENU.CONGRATS' | translate}}</h2>
        <ul>
          <li><a routerLink="/">{{'MENU.HOME' | translate}}</a></li>
          <li><i class="icofont-simple-right"></i></li>
          <li>{{'MENU.CONGRATS' | translate}}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="isLoading$ | async">
  <div class="progress progress-modal">
    <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
      style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
  </div>
</ng-container>
<div class="container">
  <div class="row" style="margin-top: 50px;">
    <div class="col-lg-2"></div>
    <div class="col-lg-3">
      <label style="font-weight: bold;margin-bottom: 5px;">{{ language == 'en'? 'Name' : 'الاسم' }}</label>
      <input class="form-control" (keyup)="UpdateText()" [(ngModel)]="Name"
        [placeholder]="language == 'en'? 'Write your name' : 'اكتب اسمك'">
    </div>
    <div class="col-lg-3">
      <label style="font-weight: bold;margin-bottom: 5px;">{{ language == 'en'? 'Font color' : 'لون الخط' }}</label>
      <select [(ngModel)]="selectedColor" (change)="UpdateText()" class="form-control">
        <option value="Black">{{ language == 'en'? 'Select color' : 'اختر اللون' }}</option>
        <option *ngFor="let color of colors" [value]="color.Value" >{{color.Name}}</option>
        <!-- <option value="">{{ language == 'en'? 'Another color' : 'لون اخر' }}</option> -->
      </select>
    </div>
    <div class="col-lg-3" *ngIf="AnotherColor">
      <label style="font-weight: bold;margin-bottom: 5px;">{{ language == 'en'? 'Another font color' : 'لون خط اخر'
        }}</label>
      <input class="form-control" (keyup)="UpdateText()" [(ngModel)]="AnotherColortxt"
        [placeholder]="language == 'en'? 'Write your color' : 'اكتب اللون'">
    </div>
  </div>
  <div class="row text-center" style="margin: 30px 0px;">
    <div class="col-lg-2"></div>
    <div class="col-lg-9">
      <canvas #myCanvas id="canvas" ></canvas>
    </div>
  </div>
  <div class="text-center" style="margin: 30px 0px;">
    <button class="btn btn-info" (click)="SaveImage()" style="margin: 10px;">
      {{ language == 'en'? 'Download Image' : 'تحميل الصورة'}}</button>
    <button class="btn btn-warning" (click)="onNoClick()">{{ 'COMMON.BACK' | translate }}</button>

  </div>

</div>
